import { getAuthorization } from 'controllers/controller';
import { rankTalentService } from 'services/talentAiMatching/rankTalent';
import { rankTalentForExplainableMatchService } from 'services/talentAiMatching/rankTalentForExplainableMatch';

export const rankTalent = async (
  jdList = [],
  resumeList = [],
  selectedJob = {}
) => {
  const authorization = getAuthorization();
  let isUploaded = true;
  const jds = [...jdList];

  if (selectedJob && selectedJob.jobId) {
    jds.push({ docId: selectedJob.jobId });
    isUploaded = false;
  }

  const jobIds = jds.map(({ docId }) => docId);
  const resumeIds = resumeList.map(({ docId }) => docId);

  const { data } = await rankTalentService(
    authorization,
    {
      jobIds,
      resumeIds,
    },
    isUploaded
  );

  return data.response.result;
};

export const rankTalentForExplainableMatch = async (
  jdContent,
  jdContentFromUI,
  resumeContent
) => {
  const authorization = getAuthorization();

  const { data } = await rankTalentForExplainableMatchService(authorization, {
    jd: {
      ...jdContent[0],
      content: {
        ...jdContent[0].content,
        job_title: jdContentFromUI.jobTitle,
        maximum_required_experience: jdContentFromUI.minExperience,
        minimum_required_experience: jdContentFromUI.maxExperience,
        raw_text: jdContentFromUI.description,
        skills: jdContentFromUI.skills,
      },
    },
    resume: {
      skills: resumeContent.content.skills,
      experience: resumeContent.content.sections,
      titles: resumeContent.content.experience,
    },
  });

  return data.result;
};
